import React, { useState } from "react";
import { useMemo } from "react";
import { Form, Label, Popup } from "semantic-ui-react";
import { useTextResources, useMessageResources } from "../../../language";
import HotelsDropDown from "../../shared/HotelsDropDown";
import SearchPanel from "../../SearchPanel";
import RoomsDropDown from "../../shared/RoomsDropDown";
import ApartmentOwnersDropDown from "../../shared/ApartmentOwnersDropDown";
import GridPanel from "../../GridPanel";
import { Reports } from '../../../api/services/next';
import { GetReservationTotals } from '../../../api/services/pms'
import { DatePicker } from "../../shared/DatePicker";
import moment from 'moment'
import { useLoader } from '../../shared/utils';
import "./style.css";
import _ from 'lodash';
import { endpoint } from '../../../api/http'
import { onWarning, onError } from "../../shared/messages";
import Panel from "../../shared/Panel";
import { dateFormat } from "../../shared/constants";

export const ApartmentOwnerReport = () => {
  const text = useTextResources();
  const message = useMessageResources();
  const loader = useLoader()

  const [incomeByReservation, setIncomeByReservation] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [selectedApartmentOwnerId, setSelectedApartmentOwnerId] = useState();
  const [selectedHotelId, setSelectedHotelId] = useState(window.optima.user.CurrentHotel?.Id);
  const [selectedRoomsCommissionFlag, setSelectedRoomsCommissionFlag] = useState();
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedRoomId, setSelectedRoomId] = useState();
  const [selectedRoomName, setSelectedRoomName] = useState();
  const [searchResult, setSearchResult] = useState();


  const monthFormat = (value) => {
    return moment(value).format("MM/YYYY")
  }

  const basicDateFormatter = (value) => {
    return moment(value).format(dateFormat)
  }

  const currencyFormat = (value) => {
    return `${value.toFixed(2)}`
  }
  const dateFormatter = ({ value }) => {
    return value && basicDateFormatter(value)
  }

  const currencyFormatter = ({ value }) => {
    if (value)
      return value && currencyFormat(value)
    else
      return 0
  }

  const reservationFormatter = ({ value, row }) => {
    if (row) {
      return <a
        target="_blank"
        rel="noopener noreferrer"
        href={`${endpoint}PMS/Reservations/Index/${row.ReservationId}?hotelid=${row.HotelId}`}>
        {value}
      </a>
    } else {
      return value
    }
  }

  const guestFormatter = ({ value, row }) => {
    return (
      <a
        target='_blank'
        rel='noopener noreferrer'
        href={`${endpoint}CRM/GuestProfile/index/?hotelid=${row.HotelId}#/profile/${row.GuestId}`}
      >
        {value}
      </a>
    )
  }

  const roomCommissionFlagIndicator = React.useCallback(item => {
    return <Popup trigger={<Label circular color={item.IsOperatorCommisionOnSumBeforeOtherCommisions ? "green" : "red"} empty />}
      position="left center"
      basic
      content={
        item.IsOperatorCommisionOnSumBeforeOtherCommisions ? message("OperatorCommissionPrecedesOtherCommissions") : message("OperatorCommissionCalculatedAfterOtherCommissions")
      }></Popup>
  }, [])

  const validateSpec = spec => {
    let isValid = true;

    if (!spec.month) {
      onWarning(message("DateIsEmpty"))
      isValid = false
    }

    if (!spec.RoomIds) {
      isValid = false
    }
    return isValid
  }

  const excelTitleRowFont = { bold: true, size: 12 };
  const excelHeaderRowFont = { bold: true, size: 10 };
  const excelSumRowFont = { bold: true, size: 12 };
  const excelHeaderRowFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DEDDD9' }, bgColor: { argb: '2E9ABE' } }

  const customizeExcelHeader = worksheet => {
    let row = worksheet.addRow([`${text("ManagementReport")} ${selectedRoomName} - ${monthFormat(selectedMonth)}`])
    worksheet.mergeCells('A1:O1');
    row.height = 20
    row.font = { bold: true, size: 16 };
    row.alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.addRow();
    let summaryTitleRow = worksheet.addRow([text("Summary")]);
    summaryTitleRow.height = 20
    summaryTitleRow.font = excelTitleRowFont;
  }

  const customizeFooter = worksheet => {
    let summaryHeaderRow = worksheet.getRow(4);
    summaryHeaderRow.font = excelHeaderRowFont;
    fillRow(summaryHeaderRow);

    let sumRow = worksheet.lastRow;
    sumRow.font = excelSumRowFont;

    worksheet.addRow();
    let expensesTitleRow = worksheet.addRow([text("CurrentExpensesDetails")]);
    expensesTitleRow.height = 20
    expensesTitleRow.font = excelTitleRowFont;

    let expensesHeaderRow = worksheet.addRow([text("Room"), text("Description"), text("Amount")]);
    expensesHeaderRow.font = excelHeaderRowFont;
    fillRow(expensesHeaderRow);

    searchResult.RoomExpenses.forEach(item => {
      worksheet.addRow([item.RoomName, item.ExpenseName, currencyFormat(item.ExpenseAmount)]);
    })

    sumRow = worksheet.addRow(["", "", "Sum: " + currencyFormat(_.sumBy(searchResult.RoomExpenses, "ExpenseAmount"))]);
    sumRow.font = excelSumRowFont;

    worksheet.addRow();
    let reservationsTitleRow = worksheet.addRow([text("Reservations")]);
    reservationsTitleRow.height = 20
    reservationsTitleRow.font = excelTitleRowFont;

    let reservationsHeaderRow = worksheet.addRow([
      text("ReservationNumber"),
      text("GuestFullName"),
      text("GuestNationality"),
      text("ReservationCustomer"),
      text("Room"),
      text("ReservationTotal"),
      text("SalesFees"),
      text("CleaningIncome"),
      text("ArrivalDate"),
      text("DepartureDate"),
      text("Nights"),
    ]);

    reservationsHeaderRow.font = excelHeaderRowFont;
    fillRow(reservationsHeaderRow);

    searchResult.Reservations.forEach(item => {
      worksheet.addRow([
        item.ReservationNumber,
        item.GuestFullName,
        item.GuestNationality,
        item.ReservationCustomer,
        item.RoomName,
        currencyFormat(item.TotalGross),
        currencyFormat(item.SalesFees),
        currencyFormat(item.Cleaning),
        basicDateFormatter(item.CheckInDate),
        basicDateFormatter(item.CheckOutDate),
        item.Nights
      ]);
    })

    sumRow = worksheet.addRow(["", "", "", "", "",
      "Sum: " + currencyFormat(_.sumBy(searchResult.Reservations, "TotalGross")),
      "Sum: " + currencyFormat(_.sumBy(searchResult.Reservations, "SalesFees")),
      "Sum: " + currencyFormat(_.sumBy(searchResult.Reservations, "Cleaning")),
      "", "",
      "Sum: " + _.sumBy(searchResult.Reservations, "Nights"),
    ]);
    sumRow.font = excelSumRowFont;
  }

  const fillRow = row => {
    row.eachCell({ includeEmpty: true }, function (cell) {
      cell.fill = excelHeaderRowFill
    });
  }

  const onSearchComplete = async (data, searchState) => {
    loader(true)

    try {
      let incomeByReservation = data.Reservations;

      const reservationsIds = incomeByReservation.map(s => s.ReservationId);
      const hotelId = searchState.HotelId;
      const totals = await GetReservationTotals({
        ReservationIDs: reservationsIds,
        HotelID: hotelId,
        TargetCurrencyId: window.user?.CurrentHotel?.MainCurrencyId || 1
      });

      if (totals && totals.length) {
        incomeByReservation.forEach(res => {
          const resTotals = totals.find(s => s.ReservationID == res.ReservationId)
          res.TotalGross = resTotals && (resTotals.TotalAmountDebitBeforeTax)
        });
      }


      setSearchResult({ Reservations: incomeByReservation, RoomExpenses: data.RoomExpenses, SummaryLines: data.SummaryLines });

      setIncomeByReservation(incomeByReservation);
      setExpenses(data.RoomExpenses);
    }
    catch (error) {
      onError(error)
    }
    finally {
      loader(false)

    }
  }

  const buildReportData_commissionsAfter = () => {
    const totalGross = _.sumBy(searchResult.Reservations, "TotalGross")
    const salesFees = _.sumBy(searchResult.Reservations, "SalesFees")
    const totalCommissions = _.sumBy(searchResult.SummaryLines, "Amount")
    const totalExpenses = _.sumBy(searchResult.RoomExpenses, "ExpenseAmount")
    const operatorCommissionPercent = (searchResult.Reservations[0] && searchResult.Reservations[0].OperatorCommissionPercent) || 0;

    const totalIncome = totalGross - salesFees - totalCommissions;
    const totalOperationCommissions = totalIncome * operatorCommissionPercent / 100
    const totalIncomeAfterOperationComimission = totalIncome - totalOperationCommissions;
    const profit = totalIncomeAfterOperationComimission - totalExpenses;

    const summary = searchResult.SummaryLines.reduce((acc, item) => {
      acc = { ...acc, [item.LineCode]: item.Amount }
      return acc
    }, {})

    let summaryObj = {
      ...summary,
      Gross: totalGross,
      SalesFees: salesFees,
      Income: totalIncome,
      OperationCommissions: totalOperationCommissions,
      IncomeAfterOperationComimission: totalIncomeAfterOperationComimission,
      RoomExpenses: totalExpenses,
      Profit: profit
    };

    return [summaryObj];
  }

  const buildReportData_commissionsBefore = () => {

    const totalGross = _.sumBy(searchResult.Reservations, "TotalGross")
    const salesFees = _.sumBy(searchResult.Reservations, "SalesFees")
    const totalCommissions = _.sumBy(searchResult.SummaryLines, "Amount")
    const totalExpenses = _.sumBy(searchResult.RoomExpenses, "ExpenseAmount")
    const operatorCommissionPercent = (searchResult.Reservations[0] && searchResult.Reservations[0].OperatorCommissionPercent) || 0;

    const totalOperationCommissions = totalGross * operatorCommissionPercent / 100
    const totalIncomeAfterOperationComimission = totalGross - totalOperationCommissions;
    const totalIncome = totalIncomeAfterOperationComimission - salesFees - totalCommissions;
    const profit = totalIncome - totalExpenses;

    const summary = searchResult.SummaryLines.reduce((acc, item) => {
      acc = { ...acc, [item.LineCode]: item.Amount }
      return acc
    }, {})

    let summaryObj = {
      ...summary,
      Gross: totalGross,
      SalesFees: salesFees,
      Income: totalIncome,
      OperationCommissions: totalOperationCommissions,
      IncomeAfterOperationComimission: totalIncomeAfterOperationComimission,
      RoomExpenses: totalExpenses,
      Profit: profit
    };

    return [summaryObj];
  }

  const summaryColumns = useMemo(() => {
    if (searchResult) {

      if (searchResult.SummaryLines && searchResult.SummaryLines.length > 0) {
        return searchResult.SummaryLines.map(line => {
          return {
            name: line.LineCode,
            title: line.TitleNeedsTranslation ? text(line.Title) : line.Title,
            formatter: currencyFormatter
          }
        })
      }
    }
    else {
      return [];
    }
  }, [searchResult])


  const summaryData = useMemo(() => {
    if (searchResult) {

      const isOperatorCommisionBeforeOtherCommisions = selectedRoomsCommissionFlag;

      if (isOperatorCommisionBeforeOtherCommisions) {
        return buildReportData_commissionsBefore()
      }
      else {
        return buildReportData_commissionsAfter()
      }
    }

  }, [searchResult])

  const incomeByReservationsGridOptions = useMemo(() => {
    return {
      columns: [
        {
          name: "ReservationNumber",
          title: text("ReservationNumber"),
          formatter: reservationFormatter
        },
        {
          name: "GuestFullName",
          title: text("GuestFullName"),
          formatter: guestFormatter
        },
        {
          name: "GuestNationality",
          title: text("GuestNationality"),
        },
        {
          name: "ReservationCustomer",
          title: text("ReservationCustomer"),
        },
        {
          name: "RoomName",
          title: text("Room"),
        },
        {
          name: "TotalGross",
          title: text("ReservationTotal"),
          formatter: currencyFormatter
        },
        {
          name: "SalesFees",
          title: text("SalesFees"),
          formatter: currencyFormatter
        },
        {
          name: "Cleaning",
          title: text("CleaningIncome"),
          formatter: currencyFormatter
        },
        {
          name: "CheckInDate",
          title: text("ArrivalDate"),
          formatter: dateFormatter
        },
        {
          name: "CheckOutDate",
          title: text("DepartureDate"),
          formatter: dateFormatter
        },
        {
          name: "Nights",
          title: text("Nights"),
        },
      ],
      summary: true,
      totalSummaryItems: [
        { columnName: 'TotalGross', type: 'sum', formatter: currencyFormatter },
        { columnName: 'SalesFees', type: 'sum', formatter: currencyFormatter },
        { columnName: 'Cleaning', type: 'sum', formatter: currencyFormatter },
        { columnName: 'Nights', type: 'sum' },
      ],
      scrollbarX: true,
      paging: true,
      pageSize: 5,
      noVirtualTable:true
    }
  }, [incomeByReservation]);

  const expensesGridOptions = useMemo(() => {
    return {
      columns: [
        {
          name: "RoomName",
          title: text("Room")
        },
        {
          name: "ExpenseName",
          title: text("Description"),
        },
        {
          name: "ExpenseAmount",
          title: text("Amount"),
          formatter: currencyFormatter
        }
      ],
      summary: true,
      totalSummaryItems: [
        { columnName: 'ExpenseAmount', type: 'sum', formatter: currencyFormatter },
      ],
      paging: true,
      pageSize: 5,
      noVirtualTable:true
    }
  }, [expenses]);


  const summaryGridOptions = useMemo(() => {
    return {
      title: text("ApartmentsOwnerReport"),
      columns: summaryColumns,
      summary: true,
      totalSummaryItems: [
        { columnName: 'Gross', type: 'sum', formatter: currencyFormatter },
        { columnName: 'Profit', type: 'sum', formatter: currencyFormatter },
      ],
      scrollbarX: true,
      export: true,
      excel: {
        customizeHeader: customizeExcelHeader,
        customizeFooter: customizeFooter,
        totalSummaryItems: [
          { columnName: 'Gross', type: 'sum', formatter: currencyFormatter },
          { columnName: 'Profit', type: 'sum', formatter: currencyFormatter },
        ],
      },
      noVirtualTable:true
    }
  }, [searchResult]);


  const searchOptions = {
    title: text("ApartmentsOwnerReport"),
    fields: [
      <Form.Field control={DatePicker} type="month"
        format="YYYY/MM"
        label={text("Month")}
        name="month"
        key="month"
        onChange={setSelectedMonth}
      />,
      <Form.Field
        key="HotelId"
        label={text("Hotel")}
        control={HotelsDropDown}
        onChange={(item) => setSelectedHotelId(item)}
        clearable
      />,
      <Form.Field
        key="ApartmentOwnerId"
        label={text("ApartmentOwner")}
        control={ApartmentOwnersDropDown}
        onChange={(item) => setSelectedApartmentOwnerId(item)}
        spec={{
          HotelId: selectedHotelId,
        }}
        clearable
      />,
      <Form.Field
        key="RoomId"
        label={text("Room")}
        control={RoomsDropDown}
        labelField={roomCommissionFlagIndicator}
        clearable
        onChange={setSelectedRoomId}
        onChangeItem={item => {
          setSelectedRoomsCommissionFlag(item && item.IsOperatorCommisionOnSumBeforeOtherCommisions);
          setSelectedRoomName(item && item.Name)
        }}
        spec={{
          HotelId: selectedHotelId,
          OwnerGuestIDs: [selectedApartmentOwnerId]
        }}
      />,
    ],
    initial: {
      HotelId: window.optima?.user?.CurrentHotel?.Id,
    },
    spec: {
      RoomIds: [selectedRoomId],
      FromDate: selectedMonth && moment(selectedMonth).startOf('month').toISOString(),
      ToDate: selectedMonth && moment(selectedMonth).endOf('month').toISOString(),
    },
    validate: validateSpec,
    api: Reports.ApartmentOwnersReport,
    description: `${text("AllCalculationsInHotelCurrency")} (${text("AmountBeforeTax")})`
  };

  return (
    <div id="ApartmentOwnerReport" style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "auto" }}>
      <SearchPanel options={searchOptions} onSearchComplete={onSearchComplete} />
      <Panel header={text("Summary")}>
        <GridPanel options={summaryGridOptions} data={summaryData} />
      </Panel>
      <Panel header={text("CurrentExpensesDetails")}>
        <GridPanel options={expensesGridOptions} data={expenses} />
      </Panel>
      <Panel header={text("Reservations")}>
        <GridPanel options={incomeByReservationsGridOptions} data={incomeByReservation} />
      </Panel>
    </div>
  )
}
